var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferState({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8698",
    "data-name": "Rectangle 8698",
    width: 16.61,
    height: 13.036,
    fill: "#0072ce"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Transfer_State"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transfer_State",
    "data-name": "Transfer State",
    clipPath: "url(#clip-Transfer_State)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11790",
    "data-name": "Group 11790",
    transform: "translate(0.695 2.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11789",
    "data-name": "Group 11789",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22252",
    "data-name": "Path 22252",
    d: "M16.61,4.9a1.668,1.668,0,0,1-.364.462Q14.3,7.3,12.357,9.244a.606.606,0,0,1-.852.119.639.639,0,0,1-.242-.54c0-.508-.007-1.016,0-1.523,0-.153-.044-.188-.19-.188q-3.121.006-6.242,0A.6.6,0,0,1,4.161,6.6c-.015-.155,0-.313,0-.47s0-.332,0-.5c-.07-.009-.09.047-.12.077Q2.8,6.941,1.56,8.179c-.081.08-.111.129-.012.228.848.84,1.69,1.687,2.534,2.531a.824.824,0,0,0,.075.055c0-.31.013-.594,0-.876a.61.61,0,0,1,.625-.639q2.343,0,4.686,0a.6.6,0,0,1,.2,1.171.674.674,0,0,1-.224.02H5.565c-.246,0-.211-.018-.211.2,0,.5,0,1,0,1.507a.606.606,0,0,1-1.07.44L1.244,9.783q-.51-.51-1.02-1.02a.6.6,0,0,1,0-.936Q2.252,5.8,4.282,3.774A.6.6,0,0,1,4.97,3.6a.619.619,0,0,1,.383.619c0,.5.01,1,0,1.507,0,.171.05.206.208.205,2.064,0,4.129,0,6.193-.007.46,0,.638.225.691.455a1.876,1.876,0,0,1,.016.4c0,.2,0,.41,0,.624a.276.276,0,0,0,.16-.107q1.232-1.231,2.464-2.462c.066-.066.084-.1.008-.18Q13.842,3.417,12.6,2.173c-.034-.033-.071-.063-.108-.1-.058.054-.03.116-.031.171,0,.216-.016.433,0,.648a.624.624,0,0,1-.675.672c-1.151-.005-2.3,0-3.453,0-.389,0-.778,0-1.167,0a.627.627,0,0,1-.638-.528.6.6,0,0,1,.6-.665c1.319,0,2.637,0,3.956,0,.136,0,.185-.022.182-.174-.011-.518,0-1.037,0-1.556A.613.613,0,0,1,11.931,0a.678.678,0,0,1,.415.227l2.74,2.738c.413.412.824.826,1.24,1.236a1.086,1.086,0,0,1,.284.4Z",
    transform: "translate(0 0)",
    fill: "#0072ce"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferState);
export default __webpack_public_path__ + "static/media/Transfer State.6afd68c194250c36dcbaa229b62d5fbc.svg";
export { ForwardRef as ReactComponent };